import React from 'react';
import {Link} from 'react-router-dom';
import Logo from '../data/logo.png'

export default function Header(){

    return (
        <div>
            <nav class="navbar" role="navigation" aria-label="main navigation">
                <div class="navbar-brand">
                    <Link to="/"><a class="navbar-item" href="/">
                    <img alt="Dini.tn" src={Logo}  height="28"></img>
                    </a></Link>

                    <a  role="button" className="navbar-burger burger" ariaLabel="menu" ariaExpanded="false" dataTarget="navbarBasicExample">
                    <span ariaHidden="true"></span>
                    <span ariaHidden="true"></span>
                    <span ariaHidden="true"></span>
                    </a>
                </div>

  <div id="navbarBasicExample" className="navbar-menu">
    <div class="navbar-end">
        <Link to="/"><a class="navbar-item">
        القرآن</a> </Link>
        <Link to="/sonna"><a class="navbar-item">
        السنة</a> </Link>
    </div>
  </div>
</nav>
<section class="hero is-info is-bold">
  <div class="hero-body">
    <div class="container">
      <h1 class="title is-1">
        القرآن الكريم
      </h1>
      <h2 class="subtitle">
        و تفسيره
      </h2>
    </div>
  </div>
</section>

</div>
    )
}
